import { DialogLayout } from "@/subframe/layouts/DialogLayout";
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { Alert } from "@/subframe/components/Alert";
import { Button } from "@/subframe/components/Button";

interface SwitchToAiAssistantPopupProps {
  open: boolean;
  setIsSwitchToAiAssistantPopupOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  onConfirm: () => void;
  onCancel: () => void;
}

function SwitchToAiAssistantPopup({
  open,
  onConfirm,
  onCancel
}: SwitchToAiAssistantPopupProps) {
  return (
    <DialogLayout open={open} onOpenChange={()=> {}}>
      <div className="flex w-96 flex-col items-start gap-6 px-6 py-6">
        <div className="flex w-full flex-col items-center gap-6">
          <div className="flex w-full flex-col items-center gap-4 px-1 py-1">
            <IconWithBackground size="large" icon="FeatherToggleRight" />
            <span className="text-heading-2 font-heading-2 text-default-font">
              Switch to AI Assistant?
            </span>
          </div>
          <div className="flex w-full flex-col items-center gap-2">
            <span className="w-full text-body font-body text-subtext-color text-center">
              Select how you&#39;d like to handle this conversation
            </span>
          </div>
          <Alert
            title="AI Assistant"
            description={
              "Enabled: Messages will be shared with your connected automation tools (Zapier, Make, etc.)\nDisabled: Messages won't sync with automation tools"
            }
          />
          <div className="flex w-full flex-col items-center gap-2">
            <Button
              className="h-10 w-full flex-none"
              onClick={onConfirm}
            >
              Hand over to AI assistant and leave
            </Button>
            <Button
              className="h-10 w-full flex-none"
              variant="neutral-secondary"
              onClick={onCancel}
            >
              Stay in conversation
            </Button>
          </div>
        </div>
      </div>
    </DialogLayout>
  );
}

export default SwitchToAiAssistantPopup;
